import T from 'T'

export const getIsCreditMemo = (total = 0) => total < 0

export const getInvoiceText = (title, isCreditMemo) => (isCreditMemo ? `${title} ${T.CREDIT_MEMO}` : title)

export const getAmount = (amount, isCreditMemo) => (isCreditMemo ? Math.abs(amount) : amount)
